var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var config = require('config');

require('./_styles.scss');
require('../../../services/activity-feed');
require('../../../services/analytics');
require('../../../services/error-modal');
require('../../../services/fullscreen-loading');
require('../../../services/thankyou-modal');
require('../../../services/user');
require('../../../filters');
require('./form');

_module.controller('ContactAgentLoCtrl', [
    '$log',
    '$q',
    '$http',
    '$user',
    '$fsloading',
    '$errorModal',
    '$analytics',
    '$thankyouModal',
    '$activityFeed',

    function ContactAgentLoCtrl($log, $q, $http, $user, $fsloading, $errorModal, $analytics, $thankyouModal, $activityFeed) {
        $log.debug('ContactAgentLoCtrl', this);

        var vm = this;
        vm.model = {
            agent: ($user.affiliate.vendorId ? null : $user.affiliate),
            vendor_user: ($user.affiliate.vendorId ? $user.affiliate : $user.affiliate.benoit_partner),
            formData: {
                agent: {},
                vendor_user: {}
            }
        };
        vm.events = {
            onAgentContactUsSubmit: onAgentContactUsSubmit,
            onLOContactUsSubmit: onLOContactUsSubmit
        };
        var affiliateProperties = [
            'first_name',
            'last_name',
            'name',
            'email',
            'phone',
            'company',
            'headshot',
            'branding',
            'vendor',
            'id',
            'vendorId'
        ];

        // Functions
        function onAgentContactUsSubmit($form) {
            $log.debug('ContactAgentLoCtrl -> onAgentContactUsSubmit -> $form', $form.$valid, $form);
            $log.debug(vm.model.formData.agent);

            if($form.$valid) {
                $fsloading.show();
                $analytics.eventTrack('nest.me Contact Form Submit', {
                    Source: 'Agent Form'
                });

                var emailData = _.extend({}, vm.model.formData.agent, { affiliate: _.pick(vm.model.agent, affiliateProperties) });
                var textMessageData = _.omit(emailData, ['body_text']);

                $q.all([
                    sendEmail(emailData),
                    sendTextMessage(textMessageData)
                ])
                .then(function () {
                    var data = _.omit(emailData, ['body_text']);
                    data.affiliate.benoit_partner = $user.affiliate.benoit_partner;

                    createActivity(data);
                    createLead(data);
                    $thankyouModal('Your message has been delivered.');

                    vm.model.formData.agent = {};
                    $form.$setPristine();
                })
                .catch(function onError(err) {
                    $log.error('ContactAgentLoCtrl -> onAgentContactUsSubmit -> Error', err);
                    $errorModal();
                })
                .finally(function () {
                    $fsloading.hide();
                });
            }
        }

        function onLOContactUsSubmit($form) {
            $log.debug('ContactAgentLoCtrl -> onLOContactUsSubmit -> $form', $form.$valid, $form);
            $log.debug(vm.model.formData.vendor_user);

            if($form.$valid) {
                $fsloading.show();
                $analytics.eventTrack('nest.me Contact Form Submit', {
                    Source: 'LO Form'
                });

                var emailData = _.extend({}, vm.model.formData.vendor_user, { affiliate: _.pick(vm.model.vendor_user, affiliateProperties) });
                var textMessageData = _.omit(emailData, ['body_text']);

                $q.all([
                    sendEmail(emailData),
                    sendTextMessage(textMessageData)
                ])
                .then(function () {
                    var data = _.omit(emailData, ['body_text']);

                    createActivity(data);
                    createLead(data);
                    $thankyouModal('Your message has been delivered.');

                    vm.model.formData.vendor_user = {};
                    $form.$setPristine();
                })
                .catch(function onError(err) {
                    $log.error('ContactAgentLoCtrl -> onLOContactUsSubmit -> Error', err);
                    $errorModal();
                })
                .finally(function () {
                    $fsloading.hide();
                });
            }
        }

        function sendEmail(data) {
            return $http.post('/v1/emails/branded-homepage-contactus', data)
            .then(function (response) {
                return response.data.data;
            });
        }

        function sendTextMessage(data) {
            return $http.post('/v1/text-messages/branded-homepage-contactus', data)
            .then(function (response) {
                return response.data.data;
            })
            .catch(function (err) {
                $log.error('ContactAgentLoCtrl -> sendTextMessage -> Error', err);

                return false;
            });
        }

        function createActivity(data) {
            if($user.account_type !== 'guest') return $q.when(null);

            var activityMetaData = {
                benoitUserId: $user.id,
                name: data.name,
                email: data.email,
                phone: data.phone
            };

            if(data.affiliate.benoit_partner) {
                activityMetaData.benoitPartnerId = data.affiliate.benoit_partner.id;
            }

            $activityFeed.add({
                avatar: 'initials',
                type: 'lead',
                name: 'benoit_agent_branded_contact_form',
                userId: data.affiliate.id,
                meta: activityMetaData
            })
            .then(function createLeadSuccess(response) {
                $log.debug('Activity Created Successfully', response.data);
            })
            .catch(function createLeadError(err) {
                $log.error('ContactAgentLoCtrl -> createActivity -> Error', err);
            });
        }

        function createLead(data) {
            var leadData = {
                applicant: {
                    name: data.name,
                    email: data.email,
                    phone: data.phone
                },
                meta: {},
                ownerId: data.affiliate.id,
                source: 'nest.me Contact Form',
                type: 'benoit'
            };

            if(data.affiliate.benoit_partner) {
                leadData.vendorId = data.affiliate.benoit_partner.vendorId;
                leadData.vendorRepId = data.affiliate.benoit_partner.id;
                leadData.agentId = data.affiliate.id;
            } else {
                leadData.vendorId = data.affiliate.vendorId;
                leadData.vendorRepId = data.affiliate.id;
            }

            $http.post(config.listreportsUrl + '/v1/leads', leadData)
            .then(function createLeadSuccess(response) {
                $log.debug('Lead Created Successfully', response.data);
            })
            .catch(function createLeadError(err) {
                $log.error('ContactAgentLoCtrl -> createLead -> Error', err);
            });
        }
    }
]);

_module.component('contactAgentLo', {
    controllerAs: 'vm',
    controller: 'ContactAgentLoCtrl',
    template: require('./index.html')
});
